import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UnitValue } from '../../../../../models/data-structures/unit-value.model';
import { NgForm } from '@angular/forms';
import { AnessaTranslationService } from '../../../../../helper/translation/anessa-translation.service';
import { ProjectCommunicationService } from '../../../../../communication/project-comms.service';
import { takeUntil } from 'rxjs/operators';
import { UserpilotReloader } from '../../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-financial-opex-estimation-confirm',
  templateUrl: './financial-opex-estimation-confirm.component.html',
  styleUrls: ['./financial-opex-estimation-confirm.component.scss']
})
/**
 * Component for the opex estimation confirmations popup. This component also includes the input
 * for the opex percentage of total capex.
 */
export class FinancialOpexEstimationConfirmComponent extends UserpilotReloader implements OnInit, OnDestroy {
  /**
   * The form that includes the opex percentage inputs
   */
  @ViewChild('opexPercentageForm') opexPercentageForm: NgForm;

  /**
   * The top position of this component.
   */
  @Input() positionTop = null;
  /**
   * The bottom position of this component.
   */
  @Input() positionBottom = null;
  /**
   * The left position of this component.
   */
  @Input() positionLeft = null;
  /**
   * The right position of this component.
   */
  @Input() positionRight = null;
  /**
   * An emitter that emits the opex percentage unit value when the confirm button is clicked.
   */
  @Output() confirmed = new EventEmitter<UnitValue>();
  /**
   * An emitter that emits when the reject button is clicked.
   */
  @Output() rejected = new EventEmitter<any>();

  /**
   * The opex percentage unit value. 5% by default, and cannot be null
   */
  opexPercentage = new UnitValue({value: 5, unit: '000000000000000000005401'});

  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger: string;
  defaultInputs = new UnitValue({value: 5, unit: '000000000000000000005401'});

  /**
   * Constructor.
   */
  constructor(
    private projectCommService: ProjectCommunicationService,
    public translationService: AnessaTranslationService,
  ) {
    super();
  }

  /**
   * On initialize.
   */
  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  isProjectInput() {
    return this.projectCommService.isProjectInput();
  }

  /**
   * Called when the confirmation button is clicked. Triggers the confirmation notifier
   */
  confirmClick() {
    if (this.opexPercentageForm.valid) {
      this.confirmed.emit(this.opexPercentage);
    } else {
      throw Error('cannot return opex percentage; invalid unit value');
    }
  }

  /**
   * Called when the reject  button is clicked. Triggers the reject notifier.
   */
  rejectClick() {
    this.rejected.emit();
  }
}
